import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import "swiper/css/pagination";
import '../assets/css/swiper.min.css';
import {
    fetchAboutUsBanner,
    fetchWhyChooseRaheja,
    fetchAwardsAccolades,
    fetchAboutPageSeo, fetchAboutHospitalSection
} from '../Adapter/PageAdapter';
// import useSeo from "../hooks/useSeo";
// import SeoHelmet from "../components/SeoHelmet";
import { Helmet } from "react-helmet-async";
import AboutBan from '../assets/images/aboutusbanner.jpg';
import AboutImg1 from '../assets/images/aboutus-left.jpg';
import googlerevew from '../assets/images/googlerevew.svg';
import accrediationImg from '../assets/images/accrediation.png';
import ceos1Img from '../assets/images/ceos1.jpg';
import ceos2Img from '../assets/images/about-ceo2.png';
import revleft from '../assets/images/revleft.jpg';
import revright from '../assets/images/revright.jpg';
import wc1Img from "../assets/images/wc1.png";
import wc2Img from "../assets/images/wc2.png";
import wc3Img from "../assets/images/wc3.png";
import wc4Img from "../assets/images/wc4.png";
import wc5Img from "../assets/images/wc5.png";
import wc6Img from "../assets/images/wc6.png";
import { baseImage_path } from '../variables/Variables';
import { stripHtmlForMeta } from '../utils/seoMetaText';

const About = () => {
    const [bannerData, setBannerData] = useState([]);
    const [whyChooseData, setWhyChooseData] = useState(null);
    const [awardsData, setAwardsData] = useState([]);
    const [seoData, setSeoData] = useState(null);
    const [aboutHospital, setAboutHospital] = useState(null);

    useEffect(() => {
        const loadSeo = async () => {
            try {
                console.log("Calling fetchAboutPageSeo...");
                const res = await fetchAboutPageSeo();
                console.log("API Response:", res);
                if (res && res.data) {
                    setSeoData(res.data);
                }
            } catch (e) {
                console.error("Direct SEO fetch failed:", e);
            }
        };

        loadSeo();
    }, []);

    useEffect(() => {
        if (!seoData?.custom_scripts) return;

        const decodeHtmlEntities = (html) => {
            const textarea = document.createElement("textarea");
            textarea.innerHTML = html;
            return textarea.value;
        };

        const decoded = decodeHtmlEntities(seoData.custom_scripts).trim();

        const match = decoded.match(
            /<script[^>]*type=["']?(.*?)["']?[^>]*>([\s\S]*?)<\/script>/i
        );

        let type = "text/javascript";
        let content = decoded;

        if (match) {
            type = match[1] || "text/javascript";
            content = match[2].trim();
        }

        // Validate JSON if it's JSON-LD
        if (type === "application/ld+json") {
            try {
                JSON.parse(content);
            } catch (err) {
                console.error("Invalid JSON-LD in custom_scripts:", err);
                return;
            }
        }

        const script = document.createElement("script");
        script.type = type;
        script.id = "seo-custom-script";
        script.text = content;

        // Remove previous if exists
        const old = document.getElementById("seo-custom-script");
        if (old) old.remove();

        document.head.appendChild(script);

        return () => {
            const cleanup = document.getElementById("seo-custom-script");
            if (cleanup) cleanup.remove();
        };
    }, [seoData?.custom_scripts]);

    // const seoData = useSeo(fetchAboutPageSeo);

    useEffect(() => {
        const fetchData = async () => {
            const bannerResponse = await fetchAboutUsBanner();
            if (bannerResponse && bannerResponse.data) {
                setBannerData(bannerResponse.data);
            }

	    const aboutResponse = await fetchAboutHospitalSection();
            if (aboutResponse) {
                setAboutHospital(aboutResponse);
            }

            const whyChooseResponse = await fetchWhyChooseRaheja();
            if (whyChooseResponse && whyChooseResponse.data.length > 0) {
                setWhyChooseData(whyChooseResponse.data[0]);
            }

            const awardsResponse = await fetchAwardsAccolades();
            if (awardsResponse && awardsResponse.data) {
                setAwardsData(awardsResponse.data);
            }
        };

        fetchData();
    }, []);

    return (
        <>

            {/* {seoData && <SeoHelmet seoData={seoData} />} */}
            {seoData && (
                <Helmet>
                    <title>{seoData.seo_title}</title>
                    <meta name="title" content={seoData.meta_title} />
                    <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
                    <meta name="keywords" content={seoData.meta_keywords} />

                    <meta property="og:title" content={seoData.og_title} />
                    <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
                    <meta property="og:type" content={seoData.og_type} />
                    <meta property="og:url" content={seoData.og_url} />
                    <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
                    <meta property="og:locale" content={seoData.og_locale} />
                    <meta property="og:site_name" content={seoData.og_site_name} />
                    <meta property="article:modified_time" content={seoData.article_modified_time} />

                    <meta name="twitter:card" content={seoData.twitter_card} />
                    <meta name="twitter:title" content={seoData.twitter_title} />
                    <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
                    <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
                    <meta name="twitter:site" content={seoData.twitter_site} />

                    <link rel="canonical" href={seoData.canonical_link} />

                    {/* Custom scripts injection */}
                  {/*     {seoData.custom_scripts && (
                        <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
                    )}  */}
                </Helmet>
            )}

            {/* Banner Section */}
            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        {bannerData && bannerData.img_path ? (
                            <img
                                src={`${baseImage_path}${bannerData.img_path.replace('.', '')}`}
                                alt={bannerData.banner_heading || "About Us"}
                            />
                        ) : (
                            <img src={AboutBan} alt="About Us Fallback" />
                        )}
                        <div className="ban-con">
                            <h1>{bannerData[0]?.banner_heading || 'About Us - Overview'}</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* About Hospital Section */}
            <section className="section about-host">
                <div className="cust-container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-4">
                            <div className="host-img">
	                    {/*   <img src={AboutImg1} alt="About Us Left" /> */}
                            <img
                                    src={
                                        aboutHospital?.img_path
                                            ? `${baseImage_path}/${aboutHospital.img_path}`
                                            : AboutImg1
                                    }
                                    alt="About Us"
                                />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-4">
                            <div className="host-det mobtopmarg">
	                      {/*  <h4>
                                    About the Hospital, <br />
                                    <span>Located in Mumbai, India</span>
                                </h4>
                                <p>
                                    Founded in 1981, S.L. Raheja Hospital—A Fortis Associate—has
                                    evolved into a premier healthcare institution known for its
                                    dedication to patient care, the latest technologies, and a
                                    wide range of specialties. Located in the vibrant neighborhood
                                    of South Bombay, Mahim, this multispecialty hospital is a go-to
                                    health partner, offering world-class medical services to
                                    thousands of patients for over 40+ years now.
                                </p>
                                <p>
                                    As one of the top hospitals for over four decades, we are one
                                    of the few dedicated to the treatment of diabetes, diabetic
                                    foot surgery, and various other multi-specialties. S.L. Raheja
                                    is a proud home to the Diabetic Association of India, the only
                                    association in India that caters to 20,000+ diabetic patients
                                    in a year and associated fields resulting from diabetic
                                    complications.
                                </p>
                                <p>
                                    Our mission is concise : To be a globally respected healthcare
                                    organization known for services efficiently.
                                </p> */}
	                         {aboutHospital && (
                                    <>
                                        <h4 dangerouslySetInnerHTML={{ __html: aboutHospital.heading }}></h4>
                                        <div
                                            className="ck-content"
                                            dangerouslySetInnerHTML={{ __html: aboutHospital.content }}
                                        ></div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us Section */}
            <section className="section towr-work aboutus-desc-margtop">
                <div className="cust-container">
                    {whyChooseData && (
                        <div className="aboutraheja-sec-inner">
                            {/* Left Section */}
                            <div className="aboutraheja-sec-inner">
                                <div className="about-raheja-sec-colfst pt-0">
                                    <div className="finnest">
                                        <h3>
                                            Why Choose <b>S.L. Raheja Hospital?</b>
                                        </h3>
                                        <p>
                                            {whyChooseData.content}
                                        </p>
                                        <div className="aboutus-howchoose">
                                            <ul>
                                                <li>
                                                    <div className="howchooseitem">
                                                        <div className="howchooseicn">
                                                            <img src={wc1Img} alt="" />
                                                        </div>
                                                        <div className="howchoosedesc">
                                                            <p>45+ Years of Trust</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="howchooseitem">
                                                        <div className="howchooseicn">
                                                            <img src={wc2Img} alt="" />
                                                        </div>
                                                        <div className="howchoosedesc">
                                                            <p>300+ Expert Doctors</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="howchooseitem">
                                                        <div className="howchooseicn">
                                                            <img src={wc3Img} alt="" />
                                                        </div>
                                                        <div className="howchoosedesc">
                                                            <p>200+ Beds with Advanced ICUs</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="howchooseitem">
                                                        <div className="howchooseicn">
                                                            <img src={wc4Img} alt="" />
                                                        </div>
                                                        <div className="howchoosedesc">
                                                            <p>6 Million+ Lives Touched</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="howchooseitem">
                                                        <div className="howchooseicn">
                                                            <img src={wc5Img} alt="" />
                                                        </div>
                                                        <div className="howchoosedesc">
                                                            <p>NABH Accredited</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="howchooseitem">
                                                        <div className="howchooseicn">
                                                            <img src={wc6Img} alt="" />
                                                        </div>
                                                        <div className="howchoosedesc">
                                                            <p>24/7 Emergency Care</p>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {/* Center Section (Image) */}
                                <div className="about-raheja-sec-colscnd">
                                    <div className="tower-img">
                                        <img
                                            src={
                                                whyChooseData && whyChooseData.main_img
                                                    ? `${baseImage_path}${whyChooseData.main_img.replace(/^\.\//, '')}`
                                                    : AboutImg1
                                            }
                                            alt="About Doctor" />
                                        <div className="pat-rev chngwidth">
                                            <div className="bck-bor">
                                                <h4>{whyChooseData.total_patients_review}+</h4>
                                                <p>
                                                    PATIENT'S <br />
                                                    REVIEWS
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Right Section (Accreditations) */}
                                <div className="about-raheja-sec-colthrd">
                                    <div className="doct-team">
                                        <img src={accrediationImg} alt="Accreditations" />
                                        <div className="doct-deta">
                                            <h6>Accreditations</h6>
                                            <div className="check-list checklistwithicn">
                                                {whyChooseData.accreditations_type
                                                    .split(',')
                                                    .map((type, index) => (
                                                        <p key={index}>{type}</p>
                                                    ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </section>

            {/* Awards Section */}
            <section className="awardcarousel-sec mrgntop70">
                <div className="cust-container">
                    <div className="awardcarousel-head">
                        <h4>Awards & Accolades</h4>
                    </div>
                    <div className="award-carousel-inner">
                        <Swiper
                            navigation={{
                                enabled: true,
                                nextEl: ".cust-swiper-button-next",
                                prevEl: ".cust-swiper-button-prev",
                            }}
                            pagination={{
                                enabled: true,
                                el: ".swiper-pagination",
                                dynamicBullets: false,
                                clickable: true,
                            }}
                            modules={[Navigation, Autoplay, Pagination]}
                            spaceBetween={2}
                            slidesPerView={1}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                    pagination: {
                                        enabled: true,
                                        el: ".swiper-pagination",
                                        dynamicBullets: true,
                                        clickable: true,
                                    },
                                    navigation: {
                                        enabled: false
                                    }
                                },
                                767: {
                                    slidesPerView: 1
                                },
                                992: {
                                    slidesPerView: 1
                                },
                                1024: {
                                    slidesPerView: 3,
                                    navigation: {
                                        enabled: true
                                    }
                                },
                                1400: {
                                    slidesPerView: 3,
                                    navigation: {
                                        enabled: true
                                    }
                                }
                            }}
                            className='awardcarousel'
                        >
                            {awardsData.map((award) => (
                                <SwiperSlide key={award.id}>
                                    <div className="awardcarousel-item">
                                        <div className="award-desc">
                                            <p>{award.heading}</p>
                                            <p>
                                                <b>{award.sub_heading}</b>
                                            </p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        {/* Swiper Navigation */}
                        <div className="hide-car-dots-ondesk">
                            <span className="swiper-pagination"></span>
                        </div>


                        <div className="hide-navonmob">
                            <div className="cust-swiper-button-prev"></div>
                            <div className="cust-swiper-button-next"></div>
                        </div>

                    </div>
                </div>
            </section>

            {/* CEO's Message Section */}
            <section className="ceos-mesg-sec mrgntop70">
                <div className="cust-container">
                    <div className="ceo-mesg-inner">
                        <div className="ceos-head">
                            <h4>
                                CEO’s <b>Message</b>
                            </h4>
                            <p>
                                At S.L. Raheja Hospital, Mahim, we are dedicated to delivering
                                world-class healthcare with compassion, innovation, and
                                excellence. Our commitment is to improve lives through advanced
                                medical expertise and personalized patient care.
                            </p>
                        </div>
                        <div className="ceos-desc">
                            <div className="ceos-itmeimg ceodescitem">
                                <img src={ceos1Img} alt="CEO 1" />
                            </div>
                            <div className="ceos-itmeimg ceodescitem">
                                <img src={ceos2Img} alt="CEO 2" />
                            </div>
                            <div className="ceos-detail ceodescitem">
                                <h5>Our MISSION</h5>
                                <p>
                                    To be globally respected healthcare organization known for
                                    Clinical Excellence and Distinctive Patient care.
                                </p>
                                <h5>Our VISION</h5>
                                <p>
                                    To create a world-class integrated healthcare delivery system
                                    in India, entailing the finest medical skills combined with
                                    compassionate patient care.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Google Reviews Section */}
            <section className="aboutus-googlerevwsec mrgntop70 margnbot90">
                <div className="cust-container">
                    <div className="aboutus-googlerevinner">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="googlervew-left">
                                    <div className="googlervew-img">
                                        <img src={revleft} alt="Google Review Left" />
                                    </div>
                                    <div className="googlervew-card">
                                        <div className="googlervwcard-img">
                                            <img src={googlerevew} alt="Google Logo" />
                                        </div>
                                        <p>
                                            This S.L. Raheja hospital truly offers a comforting and homely environment.
                                            From the moment I arrived, I felt at ease thanks to the warm and respectful
                                            attitude of the staff. Everyone is not only professional but also genuinely caring,
                                            which makes a significant difference during medical treatment.
                                        </p>
                                        <div className="googlervcard-author">
                                            <p>
                                                <i>From: L k</i>
                                            </p>
                                            <a href="https://www.google.com/search?q=sl+raheja+hospital+reviews&rlz=1C1VDKB_enIN1057IN1058&oq=sl+raheja+hospital+reviews&gs_lcrp=EgZjaHJvbWUyCQgAEEUYORiABDIICAEQABgWGB4yDQgCEAAYhgMYgAQYigUyDQgDEAAYhgMYgAQYigUyCggEEAAYgAQYogQyCggFEAAYgAQYogTSAQg3Mjc5ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#lrd=0x3be7c92f84c13ec9:0x807c1cbf1b5e8536,1,,,," target="_blank">See it on Google</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="googlervew-right">
                                    <div className="googlervew-img">
                                        <img src={revright} alt="Google Review Right" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default About;
